import React from "react";
import ModalToggle from "../../Shared/Dialogs/ModalToggle";
import Button, { SECONDARY_BUTTON, DANGER_BUTTON } from "../../Shared/Button";

const PurgeButton = ({ hidden, onConfirm }: { hidden: boolean; onConfirm: () => void }) => {
    if (hidden) {
        return <div />;
    }

    return (
        <ModalToggle
            style={{ width: "25%" }}
            className="w-1/4"
            toggleButton={(open: () => void) => (
                <Button onClick={open} styleType={DANGER_BUTTON}>
                    Purge
                </Button>
            )}
            modalContent={(hide: () => void) => {
                const handleConfirm = (): void => {
                    onConfirm();
                    hide();
                };

                return (
                    <div>
                        <div className="text-xl">Are you sure you want to purge this campaign?</div>
                        <p className="py-6">
                            This will remove all ad groups from the campaign, including any that were created outside of
                            Fuel.{" "}
                        </p>
                        <div className="flex flex-right items-center ">
                            <Button styleType={SECONDARY_BUTTON} onClick={hide}>
                                Cancel
                            </Button>
                            <Button styleType={DANGER_BUTTON} onClick={handleConfirm}>
                                Confirm
                            </Button>
                        </div>
                    </div>
                );
            }}
        />
    );
};

export default PurgeButton;
